<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5a27 27 0 1027 27A27 27 0 0032 5zm0 51a24 24 0 1124-24 24 24 0 01-24 24z"/><path d="M32 26.5a1.5 1.5 0 00-1.5 1.5v15.5a1.5 1.5 0 003 0V28a1.5 1.5 0 00-1.5-1.5zM33.85 19.73a1.63 1.63 0 00-.19-.34 2.16 2.16 0 00-.55-.55 1.63 1.63 0 00-.34-.19 1.82 1.82 0 00-.38-.11 2 2 0 00-1.8.55 1.42 1.42 0 00-.25.3 2.27 2.27 0 00-.19.34 1.66 1.66 0 00-.11.38 1.72 1.72 0 000 .39 2 2 0 00.59 1.41 1.88 1.88 0 00.64.44 2 2 0 00.77.15 2 2 0 002-2 1.72 1.72 0 000-.39 1.66 1.66 0 00-.19-.38z"/></svg>